export default "/images/cbaabafd336049644f7d4efbfa6be629.avif";